import React from 'react';
import PropTypes from 'prop-types';

const FormTableCollapsedRow = ({ spanning = 1, children }) => {
  return (
    <td className="collapsed-row" colSpan={spanning}>
      {children}
    </td>
  );
};

FormTableCollapsedRow.propTypes = {
  spanning: PropTypes.number,
  children: PropTypes.any,
};

export default FormTableCollapsedRow;
